import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const syncLang = () => {
      document.documentElement.lang = i18n.language;
    };

    syncLang();
  }, [i18n.language]);

  return null;
}